"use strict";
angular.module('correspondentServiceModule', ['correspondentDetailModule']).factory('correspondentService', ['$q', 'trsHttpService', '$modal', function($q, trsHttpService, $modal) {
    return {
    	/**
    	 * [editCorrespondent description] 通讯员详情
    	 * @param  {[type]} correspondentId [description] 通讯员ID
    	 * @return {[type]}                 [description]
    	 */
    	correspondentDetail: function(correspondentId) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/correspondent/service/correspondentDetail/correspondentDetail_tpl.html",
                    windowClass: 'correspondent-detail-window',
                    backdrop: false,
                    controller: "correspondentDetailController",
                    resolve: {
                        correspondentId: function() {
                            return correspondentId;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve("success");
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
    };
}]);